import styled from 'styled-components';

export const SwitchContainer = styled('div')`
position: absolute;
top: 4rem;
right: 4rem;
color: transparent;

`;
